import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { Button, Icon } from 'components/chroma';
import { SCREEN } from 'scenes/common/types/screen';

const PreviousButtonWrapper = styled.div`
  height: 3rem;
  margin-left: -5px;
  margin-bottom: 1rem;

  @media (max-width: ${SCREEN.LARGE}px) {
    padding-left: 16px;
  }

  .c-btn--tertiary {
    padding: 0 0.5em;
    margin-left: -0.5em;
  }

  @media (min-width: ${SCREEN.SMALL}px) and (max-width: ${SCREEN.MEDIUM -
    1}px) {
    .c-btn--tertiary {
      margin-left: -1em;
    }
  }

  @media (min-width: ${SCREEN.MEDIUM}px) and (max-width: ${SCREEN.LARGE -
    1}px) {
    .c-btn--tertiary {
      margin-left: -1.5em;
    }
  }

  @media (width: ${SCREEN.LARGE}px) {
    .c-btn--tertiary {
      margin-left: -1em;
    }
  }
`;

export const PreviousButton: FunctionComponent<{
  onPrevious: () => void;
  hasPreviousButton: boolean;
}> = ({ onPrevious, hasPreviousButton }) => (
  <PreviousButtonWrapper>
    {hasPreviousButton && (
      <Button tertiary margin={{ top: 2 }} onClick={onPrevious}>
        <Icon name="angleLeft" margin={{ right: 0.5 }} />
        Previous
      </Button>
    )}
  </PreviousButtonWrapper>
);

export default PreviousButton;
